import React from "react"
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell,
} from "recharts"
import { CHART_COLORS } from "../constants"

export default function VelocityBottleneckChart({ byStage = [] }) {
  if (!byStage.length) return null

  const data = byStage
    .filter((s) => s.avg_days != null)
    .map((s) => ({
      name: s.stage.name,
      avg_days: s.avg_days,
      p50: s.p50,
      p90: s.p90,
    }))

  if (!data.length) return null

  const maxDays = Math.max(...data.map((d) => d.p90 || d.avg_days || 0))

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4">
      <div className="mb-3 text-[13px] font-medium text-slate-700">
        Time in Stage (bottleneck view)
      </div>
      <ResponsiveContainer width="100%" height={Math.max(data.length * 56, 180)}>
        <BarChart data={data} layout="vertical" barCategoryGap="20%">
          <CartesianGrid strokeDasharray="3 3" stroke="#eef2f6" horizontal={false} />
          <XAxis type="number" tick={{ fontSize: 12 }} domain={[0, Math.ceil(maxDays * 1.1)]} unit="d" />
          <YAxis dataKey="name" type="category" tick={{ fontSize: 12 }} width={120} />
          <Tooltip formatter={(v) => [`${v} days`, ""]} />
          <Bar dataKey="avg_days" radius={[0, 4, 4, 0]} name="Avg days">
            {data.map((d, i) => (
              <Cell
                key={i}
                fill={d.avg_days === Math.max(...data.map((x) => x.avg_days || 0))
                  ? CHART_COLORS.lost
                  : CHART_COLORS.primary}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
